export class RenaultOnlinePaymentFilter {
    idStatus: number | null;
    cashoutDateInit: string | null;
    cashoutDateEnd: string | null;
    orderCreationDateInit: string | null;
    orderCreationDateEnd: string | null;
    isAdminRenault: boolean;
    taxNumber: string | null;
    accountNumber: number | null;

    constructor(isAdminRenault) {
        this.isAdminRenault = isAdminRenault;
    }
}

export class RenaultOnlinePaymentDashboard {
    TotalCashoutAmount: string;
    TotalCashoutCount: string;
    Status: RenaultOnlinePaymentDashboardStatus[] = [];
}

export class RenaultOnlinePaymentDashboardStatus {
    Status: string;
    Count: string;
}